// Components
import { MenuMobile } from '@/components/layouts/LayoutPlatform/components/Menu/MenuMobile';
import { LeftSide } from '@/components/layouts/LayoutPlatform/components/Header/LeftSide';
import { GlobalInfoDisclaimer } from '@/components/layouts/LayoutPlatform/components/Header/components/GlobalInfoDisclaimer';
import OnboardingTasks from '@/components/layouts/LayoutPlatform/components/Header/components/OnboardingTasks';

export function HeaderPlatform() {
    return (
        <div className="relative z-1 flex items-center justify-between gap-3 px-3 pb-3 pt-[50px] sm:px-0 sm:pt-3">
            <div className="flex items-center">
                <MenuMobile />
                <LeftSide />
            </div>
            <div className="flex flex-1 items-center justify-end gap-5">
                <OnboardingTasks />
                <GlobalInfoDisclaimer />
            </div>
        </div>
    );
}
